import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IMAGE_SRC } from '../../shared-constants';
import { CONSTANTS, TwoColumnFormData } from './two-column-form.constants';

@Component({
  selector: 'app-two-column-form',
  templateUrl: './two-column-form.component.html',
  styleUrls: ['./two-column-form.component.scss'],
  standalone: false,
})
export class TwoColumnFormComponent {
  @Input({ required: true }) assignedHeaderText!: string;
  @Input({ required: true }) assignedData!: TwoColumnFormData[];
  @Input({ required: true }) availableHeaderText!: string;
  @Input({ required: true }) availableData!: TwoColumnFormData[];

  @Input() availableButtonText = CONSTANTS.ASSIGN_BUTTON_TEXT;
  @Input() availableButtonIcon = IMAGE_SRC.ADD_CIRCLE;
  @Input() availableSearchPlaceholderText = CONSTANTS.SEARCH_PLACEHOLDER;
  @Input() assignedButtonText = CONSTANTS.UNASSIGN_BUTTON_TEXT;
  @Input() assignedButtonIcon = IMAGE_SRC.REMOVE_CIRCLE;
  @Input() assignedSearchPlaceholderText = CONSTANTS.SEARCH_PLACEHOLDER;

  @Output() updateAssignedValues = new EventEmitter<TwoColumnFormData[]>();

  readonly DISPLAY_CONSTANTS = CONSTANTS;
  readonly IMAGES = IMAGE_SRC;

  disableAssignedColumn = false;
  disableAvailableColumn = false;

  onAssignUnassign($event: TwoColumnFormData[], isAssignedData: boolean): void {
    if (isAssignedData) {
      this.availableData = this.availableData.concat($event);
      $event.forEach((item) => {
        this.assignedData = this.assignedData.filter((value) => {
          return value.data.code !== item.data.code;
        });
      });
    } else {
      this.assignedData = this.assignedData?.concat($event);
      $event.forEach((item) => {
        this.availableData = this.availableData.filter((value) => {
          return value.data.code !== item.data.code;
        });
      });
    }
    this.sortValues();
    this.updateAssignedValues.emit(this.formatTotalData());
  }

  onCheckValue(newValue: boolean, clickedAvailableRoutes: boolean): void {
    if (clickedAvailableRoutes) {
      this.disableAssignedColumn = !newValue;
    } else {
      this.disableAvailableColumn = !newValue;
    }
  }

  private sortValues() {
    this.disableAssignedColumn = false;
    this.disableAvailableColumn = false;
    this.availableData.sort((a, b) => a.data?.code.localeCompare(b.data?.code));
    this.assignedData.sort((a, b) => a.data?.code.localeCompare(b.data?.code));
  }

  private formatTotalData() {
    const assignedValues = [...this.assignedData].map((value) => {
      return { data: value.data, selected: true };
    });
    const availableValues = [...this.availableData].map((value) => {
      return { data: value.data, selected: false };
    });
    return [...assignedValues, ...availableValues];
  }
}
